import { useCallback, useState, useMemo, useEffect } from 'react';
import JoditEditor from 'jodit-react';
import ErrorBoundary from './ErrorFallback';

export default function App() {
    const [content, setContent] = useState('');
    const [logs, setLogs] = useState([]);
    const appendLog = useCallback(
        (message: any) => {
            console.log('logs = ', logs);
            const newLogs: any = [...logs, message];
            setLogs(newLogs);
        },
        [logs, setLogs]
    );

    const config = useMemo(
        () => ({
            readonly: false
        }),
        []
    );

    const onChange = useCallback(
        (newContent: any) => {
            appendLog(`onChange triggered with ${newContent}`);
        },
        [appendLog]
    );

    useEffect(() => {
        console.log('onChange = ', onChange);
    }, [onChange]);

    const onBlur = useCallback(
        (newContent: any) => {
            appendLog(`onBlur triggered with ${newContent}`);
            setContent(newContent);
        },
        [appendLog, setContent]
    );

    return (
        <ErrorBoundary fallback={<div className='fw-500 font-inter'>Invalid Action, please refresh!</div>}>
            <div>
                <JoditEditor value={content} config={config} onBlur={onBlur} onChange={onChange} />
                <h3>Logs</h3>
                <div>
                    {logs.map((log, index) => (
                        <p key={index}>{log}</p>
                    ))}
                </div>
                <button onClick={() => appendLog('hello')}>Add</button>
            </div>
        </ErrorBoundary>
    );
}
